import type {
  ObjectToolbarConfig,
  RegisterToolbarConfigArgs,
} from '@/blocks/object-toolbar';

/**
 * Register toolbars are type-level: no `parentObject` (permissions resolve
 * against the type) and no `save` (a list page has no form).
 *
 * The caller only supplies `create` when the server returned at least one
 * schedulable task type, so no client-side permission gate is applied here.
 * `editRibbon` is accepted so the overflow "Edit" group appears for free once
 * `scheduler_schedule` has a perm_v2 custom-ribbon resource; until then the
 * ribbon never publishes an opener and it arrives `undefined`.
 */
export const buildSchedulerRegisterToolbarConfig = ({
  title,
  counter,
  exportOptions,
  create,
  editRibbon,
}: RegisterToolbarConfigArgs): ObjectToolbarConfig => ({
  header: { title, counter },
  actions: {
    ...(create
      ? {
          primary: [
            {
              id: 'create',
              label: create.label,
              iconName: 'plus',
              onClick: create.onClick,
            },
          ],
        }
      : {}),
    ...(editRibbon
      ? {
          overflow: [
            {
              id: 'edit',
              label: editRibbon.groupLabel,
              actions: [
                {
                  id: 'edit-ribbon',
                  label: editRibbon.label,
                  iconName: 'filter-lines',
                  onClick: editRibbon.onClick,
                },
              ],
            },
          ],
        }
      : {}),
    export: [
      {
        id: 'export',
        actions: exportOptions.map((option) => ({
          id: option.id,
          label: option.text,
          iconName: 'download-01',
          onClick: option.exportFunction,
          disabled: option.disabled,
        })),
      },
    ],
  },
});
